<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<span class="mgr_5"> <CustomMonthPicker v-model="month_from"/> ~ <CustomMonthPicker v-model="month_to"/></span>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<table class="list_tbl">
			<thead>
				<tr>
					<th style="width: 200px;">Category</th>
					<th style="width: 300px;">Item Code</th>
					<th>Item Name</th>
					<th style="width: 150px;">Exp. Date</th>
					<th style="width: 100px;">Current Qty</th>
					<th style="width: 100px;">Currens CS</th>
					<th style="width: 80px;">U/M</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in items" v-bind:key="index">
					<td class="al_left">{{ item.category }}</td>
					<td class="al_left">{{ item.item_code }}</td>
					<td class="al_left truncate">{{ item.name }}</td>
					<td class="al_right">{{ item.exp_month_formatted }}</td>
					<td class="al_right">{{ item.on_hand | commaSeparated }}</td>
					<td class="al_right">{{ item.current_cs_formatted }}</td>
					<td class="al_center">{{ item.unit_code }}</td>
				</tr>
			</tbody>
		</table>
		<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<div class="bottom_bt_box">
			<ul>
				<li><a href="javascript:void(0);" v-on:click="excel">Excel</a></li>
				<li><a href="javascript:void(0);" v-on:click="print">Print</a></li>
			</ul>
		</div>
	</div>
</template>

<script>
import { toMonthYearText } from '@/utils/date';
import moment from 'moment';
import Paging from '@/components/common/Paging';
import CustomMonthPicker from '@/components/common/CustomMonthPicker.vue';
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiSelectShortDateList } from '@/api/report/report.js';
import { exportDataExcel, reportMrtUrl, reportRender } from '@/api/util';
import { defaultDataType } from 'export-xlsx';

export default {
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,
			active_only: true,

			month_from: toMonthYearText(2),
			month_to: toMonthYearText(),

			items: [],

			modalName: '',
			showModal: false,

			sort_key: null,
			sort_direction: 'ASC',
		};
	},
	props: ['headers'],
	computed: {
		user: function() {
			return this.$session.get('user');
		},
	},
	components: {
		CustomMonthPicker,
		Paging,
	},
	methods: {
		async getData() {
			let date_from = null;
			if (this.month_from) {
				date_from = moment(this.month_from, 'MM-YYYY')
					.startOf('month')
					.format('MM-DD-YYYY');
			}

			let date_to = null;
			if (this.month_to) {
				date_to = moment(this.month_to, 'MM-YYYY')
					.endOf('month')
					.format('MM-DD-YYYY');
			}
			const { data } = await apiSelectShortDateList({
				paging_yn: 'N',
				sort_key: this.sort_key,
				sort_direction: this.sort_direction,

				date_from: date_from,
				date_to: date_to,
			});

			return data;
		},

		async print() {
			const data = await this.getData();

			data.month_from = this.month_from;
			data.month_to = this.month_to;
			data.by = this.user.user_id;

			data.shortDateList = (data.shortDateList || []).map(item => {
				item.exp_month_formatted = item.exp_month ? moment(item.exp_month, 'MM-DD-YYYY').format('MMM-YYYY') : '';
				const cs = parseFloat(item.current_cs);
				item.current_cs_formatted = !isNaN(cs) ? cs.toFixed(1) : null;
				return item;
			});

			await reportRender(data, 'ShortDateList', reportMrtUrl('ShortDateList'));
			//console.log(data);
		},
		async excel() {
			const data = await this.getData();

			//var vm = this;
			let items_for_excel = data.shortDateList;

			items_for_excel = (data.shortDateList || []).map(item => {
				item.exp_month_formatted = item.exp_month ? moment(item.exp_month, 'MM-DD-YYYY').format('MMM-YYYY') : '';
				const cs = parseFloat(item.current_cs);
				item.current_cs_formatted = !isNaN(cs) ? cs.toFixed(1) : null;
				return item;
			});

			let fileName = 'ShortDateList';
			if (this.month_from) fileName += '_' + this.month_from;
			if (this.month_to) fileName += '_' + this.month_to;

			let headers = [
				{ key: 'category', name: 'Category', width: 20, dataType: defaultDataType.string },
				{ key: 'item_code', name: 'Item Code', width: 45, dataType: defaultDataType.string },
				{ key: 'name', name: 'Item Name', width: 100, dataType: defaultDataType.string },
				{ key: 'exp_month_formatted', name: 'Exp. Date', width: 20, dataType: defaultDataType.string, style: { alignment: { horizontal: 'right' } } },
				{ key: 'on_hand', name: 'Current Qty', width: 12, dataType: defaultDataType.currency },
				{ key: 'current_cs_formatted', name: 'Current CS', width: 12, dataType: defaultDataType.currency, style: { alignment: { horizontal: 'right' } } },
				{ key: 'unit_code', name: 'U/M', width: 10, dataType: defaultDataType.string, style: { alignment: { horizontal: 'center' } } },
			];

			exportDataExcel(items_for_excel, headers, fileName);
		},
		sortMark: function(sort_key) {
			if (this.sort_key == sort_key) return this.sort_direction == 'ASC' ? '▲' : '▼';
			else return null;
		},
		sort(sort_key) {
			if (this.sort_key == sort_key) {
				this.sort_direction = this.sort_direction == 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			this.selectShortDateList();
			//console.log(sort_key);
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectShortDateList(pageNo);
		},
		reset() {
			this.month_from = toMonthYearText(2);
			this.month_to = toMonthYearText();
		},
		search() {
			this.selectShortDateList();
		},
		async selectShortDateList(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;

			let date_from = null;
			if (this.month_from) {
				date_from = moment(this.month_from, 'MM-YYYY')
					.startOf('month')
					.format('MM-DD-YYYY');
			}

			let date_to = null;
			if (this.month_to) {
				date_to = moment(this.month_to, 'MM-YYYY')
					.endOf('month')
					.format('MM-DD-YYYY');
			}

			const param = {
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),
				sort_key: this.sort_key,
				sort_direction: this.sort_direction,

				date_from: date_from,
				date_to: date_to,
			};

			//console.log(param);

			const { data } = await apiSelectShortDateList(param);

			//console.log(data);

			this.items = (data.shortDateList || []).map(item => {
				item.exp_month_formatted = item.exp_month ? moment(item.exp_month, 'MM-DD-YYYY').format('MMM-YYYY') : '';
				const cs = parseFloat(item.current_cs);
				item.current_cs_formatted = !isNaN(cs) ? cs.toFixed(1) : null;
				return item;
			});
			this.list_count = data.list_count;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			var uri = '/report/short_date?month_from=' + this.month_from + '&month_to=' + this.month_to;
			this.uri = uri;
		},
		async index() {},
		async init() {
			if (this.$route.query.month_from) this.month_from = this.$route.query.month_from;
			if (this.$route.query.month_to) this.month_to = this.$route.query.month_to;

			await this.selectShortDateList(this.$route.query.page_no);
		},
	},
	created() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_short_date');
		this.$store.commit('setSubTitle', 'Item -> Short Date Report');

		this.init();
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style></style>
